import React, { Children, useEffect, useState, useRef } from 'react'
import classes from "../Sigfox/SigFoxContentLayout.module.css";
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import RemoveCamectIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/trash.png"
import { removeAibox, unlinkSigfoxAPI } from '../../../../../../Api Methods/Api';
import unavailable from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unavailable.png'
import confirmation from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/confirmation.png'
import Button1 from '../../../../Button/Button1';
import { format } from 'date-fns';

const IntegrationContentLayout = ({ integration, pin, fetchVirtualSources }) => {

    console.log(JSON.parse(integration.extraField2))

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const integrationTitle = integration.integrationType
    const ID = integration.extraField1
    const pinName = pin.pinName

    const parsed = integration?.extraField2
        ? JSON.parse(integration.extraField2)
        : [];

    const zoneName = ` ${parsed?.[0]?.zoneName || ""}`;
    let isControllingType = parsed?.[0]?.controlLevel || ""
    if (isControllingType == "output_relay") isControllingType = "Relays"
        if (isControllingType == "channel") isControllingType = "Channels"
    const isControlling = parsed?.[0]?.ruleUUIDs || ""
    console.log(isControlling)

    const addedBy = integration.addedBy
    const dateAdded = integration.created_at

    const apiData = {
        token,
        client
    }

    //------------------------------- Modal Logic  ----------------------------------------------
    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("")
    const [modalComponent, setModalComponent] = useState()
    //--------------------------------------------------------------------------------------------
    const [modalPageIndex, setModalPageIndex] = useState(null);

    const [showAddCamect, setShowAddCamect] = useState(false);

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setShowAddCamect(null);
        setModalPageIndex(null);
    }

    const dispatch = useDispatch();
    const DeviceDetails = useSelector(state => state.service.DeviceDetails)

    const unlinkAIBOX = async () => {
        const responseData = await removeAibox(apiData, DeviceUUID, pin.Pin, dispatch)
        if (responseData) {
            HandleCloseModal();
            fetchVirtualSources();
        }
    }

    const unlink = () => {
        if (integrationTitle == "AJAX"){
            setModalTitle("Sorry!")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.modalIcon} src={unavailable}>
                    </img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>{"You can unlink Ajax devices using the mobile app. This feature isn’t supported in the Portal right now."}</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                    </div>
                </div>
            )
            HandleShowModal()
        }
        else if (integrationTitle == "HIKVISION"){
            setModalTitle("Sorry!")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.modalIcon} src={unavailable}>
                    </img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>{"You can unlink Hikvision devices using the mobile app. This feature isn’t supported in the Portal right now."}</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                    </div>
                </div>
            )
            HandleShowModal()
        }
        else if (integrationTitle == "DAHUA"){
            setModalTitle("Sorry!")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.modalIcon} src={unavailable}>
                    </img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>{"You can unlink Dahua devices using the mobile app. This feature isn’t supported in the Portal right now."}</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                    </div>
                </div>
            )
            HandleShowModal()
        }
        else if (integrationTitle == "AIBOX"){
            console.log("here")
            //perform delete!
            setModalTitle("Are you sure?")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.modalIcon} src={confirmation}>
                    </img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>{"Are you sure you want to unlink this AIBOX?"}</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <Button1 onClick={unlinkAIBOX} style={{ width: "100%" }}>Yes, unlink</Button1>
                        <br></br>
                        <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>No, cancel</Button1>
                    </div>
                </div>
            )
            HandleShowModal();
        }
    }

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "600px", minHeight: "270px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <div className={classes.IntegrationContentLayout} >
                <div className={classes["left-wrapper"]}>
                    <h3 className={classes.integrationTitle}>{`${integrationTitle}${zoneName}`}</h3>
                    <h3 className={classes.subtitle}>
                    {isControllingType !== "rule"
                        ? `${isControllingType} ${isControlling}`
                        : "Rules"}
                    </h3>                    
                    <p style={{fontSize: "11px", fontStyle:"bold", margin:"0px", maxWidth:"220px"}} className={classes.subtitle}>{ID}</p>

                    
                        { addedBy && <small style={{fontSize: "9px", fontStyle:"italic", marginTop: integrationTitle === "HIKVISION" || integrationTitle === "DAHUA" ? "10px" : "2px", maxWidth:"220px"}}>{`Added by ${addedBy.fullName} on ${format(new Date(dateAdded), "MMM do, yyyy")}`}</small>}
                    
                </div>

                <div className={classes["right-wrapper"]}>

                    <div className={classes["text-container"]} >
                        <h3 className={classes.pinName}>{pinName} </h3>
                    </div>

                    <div className={classes["Icons-Container"]} >
                        <img className={classes.Icon} src={RemoveCamectIcon} onClick={() => unlink()} />
                    </div>
                </div>
            </div >
            
        </>
    )
}

export default IntegrationContentLayout;




